import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { sucursalRoutesMap } from './SucursalRoutesMap'

const AppSucursalGestion = Loadable(lazy(() => import('./view/listado/Sucursal')))
const AppRolesNuevo = Loadable(lazy(() => import('./view/registro/SucursalRegistro')))
const AppRolesActualizar = Loadable(
  lazy(() => import('./view/actualizar/SucursalActualizar')),
)

const sucursalRoutes = [
  {
    path: sucursalRoutesMap.gestion.path,
    element: <AppSucursalGestion />,
    auth: authRoles.admin,
  },
  {
    path: sucursalRoutesMap.nuevo.path,
    element: <AppRolesNuevo />,
    auth: authRoles.admin,
  },
  {
    path: `${sucursalRoutesMap.modificar.path}/:id`,
    element: <AppRolesActualizar />,
    auth: authRoles.admin,
  },
]

export default sucursalRoutes
